// src/Login.js
import React, { useState } from "react";
import { Container, Typography, TextField, Button, Alert, Box, Link } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Login = ({ onLoginSuccess, onRegisterClick, onForgotPasswordClick, onBackToHome }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMsg("");
    setLoading(true);
    // Minimal login: accept any non-empty credentials.
    if (username.trim() && password.trim()) {
      localStorage.setItem("token", "dummy-token");
      // Store username in localStorage to use for task creation attribution
      localStorage.setItem("username", username.trim());
      setLoading(false);
      onLoginSuccess();
    } else {
      setErrorMsg("Invalid username or password.");
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" style={{ marginTop: "50px" }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        {onBackToHome && (
          <Button 
            startIcon={<ArrowBackIcon />} 
            onClick={onBackToHome} 
            sx={{ mr: 2 }}
            variant="outlined"
          >
            Back to Home
          </Button>
        )}
        <Typography variant="h4">
          Staff Login
        </Typography>
      </Box>
      {errorMsg && <Alert severity="error">{errorMsg}</Alert>}
      <form onSubmit={handleSubmit}>
        <TextField
          label="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          fullWidth
          margin="normal"
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          style={{ marginTop: "20px" }}
          disabled={loading}
          fullWidth
        >
          {loading ? "Logging in..." : "Login"}
        </Button>
        <Box mt={2} textAlign="center">
          <Link 
            component="button" 
            variant="body2" 
            onClick={onRegisterClick}
          >
            Don't have an account? Register
          </Link>
        </Box>
        <Box mt={1} textAlign="center">
          <Link 
            component="button" 
            variant="body2" 
            onClick={onForgotPasswordClick}
          >
            Forgot password?
          </Link>
        </Box>
      </form>
    </Container>
  );
};

export default Login;